import ConfigService from "../../../services/ConfigService";
import {Component} from "preact";
import style from './styles.scss';

export default class Icon extends Component {

    static defaultProps = {
        icon: null
    };

    constructor() {
        super();

        this.state = {
            request: null,
            iconRequest: {value: null, error: false, loading: true},
        }
    }

    componentDidMount() {
        ConfigService.iconBaseUrl.subscribe(this.updateIcon, true);
    }

    componentWillUnmount() {
        ConfigService.iconBaseUrl.unsubscribe(this.updateIcon);
    }

    updateIcon = () => {
        if (this.state.request) this.state.request.abort();
        const request = new XMLHttpRequest();
        request.addEventListener('load', () => this.setState({iconRequest : {value: request.status === 200 ? request.responseText : null, loading: false, error: false}}));
        request.addEventListener('error', () => this.setState({iconRequest : {value: null, loading: false, error: true}}));
        request.addEventListener('abort', () => this.setState({iconRequest : {value: null, loading: false, error: true}}));
        request.addEventListener('timeout', () => this.setState({iconRequest : {value: null, loading: false, error: true}}));
        request.addEventListener('loadend', () => this.setState({request: null}));
        request.open('GET', `${ConfigService.iconBaseUrl()}/${this.props.icon}.svg`);
        request.send();
        this.setState({request})
    }

    render(props, state, context) {
        return <div className={style.container}>
            {state.iconRequest.loading ? <span className={style.loading} /> : null}
            {!state.iconRequest.loading && (state.iconRequest.error || !state.iconRequest.value) ? <span className={style.error} /> : null}
            {!state.iconRequest.loading && !state.iconRequest.error && state.iconRequest.value ? <span className={style.success} dangerouslySetInnerHTML={{__html: state.iconRequest.value}}/> : null}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./components/common/icon/index.js